import { Dialog, Text } from "@asayinc/component-library";
import { Stack } from "@mui/material";
import { toast } from "react-toastify";
import { useSendShareRangeAnalysisReportMutation } from "src/store/shareRangeAnalysisEvent";
import { useCurrentUserQuery } from "src/store/user";

interface ISendShareRangeAnalysisReportDialogProps {
  isOpen: boolean;
  onClose: () => void;
  shareRangeAnalysisEventId: string;
}

export function SendShareRangeAnalysisReportDialog({
  isOpen,
  onClose,
  shareRangeAnalysisEventId,
}: ISendShareRangeAnalysisReportDialogProps) {
  const [sendReport, { isLoading }] = useSendShareRangeAnalysisReportMutation();
  const { data: currentUser } = useCurrentUserQuery();

  const onSubmit = () => {
    sendReport({ id: shareRangeAnalysisEventId })
      .unwrap()
      .then(() => {
        toast.success("Share Range Analysis report sent successfully");
      })
      .catch((e) => {
        toast.error(e?.data?.message || "Failed to send report");
      })
      .finally(() => {
        onClose();
      });
  };

  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      fullWidth
      title="Send Share Range Analysis Report"
      buttonActions={[
        {
          label: "Cancel",
          onClick: onClose,
          variant: "secondary",
          size: "small",
        },
        {
          label: "Confirm",
          onClick: onSubmit,
          loading: isLoading,
          size: "small",
        },
      ]}
      content={
        <Stack gap={2}>
          <Text variant="body2">
            This Share Range Analysis report will be sent to{" "}
            <strong>{currentUser?.email}</strong>.
          </Text>
        </Stack>
      }
      ctaOrientation="horizontal"
    />
  );
}
